import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Error from "../../ErrorPages/Error";
import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import moment from "moment/moment";
import Swal from "sweetalert2";
import ReturnDailyPlanMaterialModal from "./modal/ReturnDailyPlanMaterialModal";

const DailyProductionEdit = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const userID = secureLocalStorage.getItem("userID");
    const location = useLocation();
    const navigate = useNavigate();

    const { invalidateApi } = useGlobalAPIQueryContext();

    console.log(location.state?.data);

    const [productionData, setProductionData] = useState();

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm();

    const { useFetch: useFetchDailyPlan, useUpdate: useUpdateDailyPlan } =
        useAPIQuery({
            key: "daily-plan",
            endpoint: "/api/daily-plan/",
        });
    const { useFetch: useFetchUpdatedData } = useAPIQuery({
        key: "api/machine-production",
        endpoint: "/api/machine-production/",
    });

    const { data: dailyPlanData, isLoading: loadingDailyPlanData } =
        useFetchDailyPlan({
            params: {
                q: location.state?.data?.daily_plan_code,
                c: "daily_plan",
            },
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        });

    const { data, error, refetch, isFetching } = useFetchUpdatedData({
        params: {
            nodeid: location.state?.data?.machine?.node_id,
            dp_code: location.state?.data?.daily_plan_code,
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 0,
        retry: 1,
        keepPlaceholder: true,
        refetchOnReconnect: true,
        enabled: false,
    });

    const { mutate, isPending } = useUpdateDailyPlan({
        params: {
            action: "update_manual_count",
        },
        successMessageFromServer: true,
        errorMessageFromServer: true,
        onSuccess: () => {
            invalidateApi({ key: "api/return/slip" });
            invalidateApi({ key: "daily-plan" });
        },
        retry: 2,
    });

    const onSubmit = (data) => {
        console.log(data);
        const res = {
            daily_production_quantity_manual:
                data?.daily_production_quantity_manula,
            // on_hold_count: data?.on_hold_count,
            // rejection_count: data?.rejection_count,
            updated_by: userID,
            wo_id: productionData?.wo?.id,
            item_id: productionData?.item?.id,
            machine_id: productionData?.machine?.id,
            date: productionData?.date,
        };
        mutate({
            id: productionData?.id,
            data: res,
        });
    };

    useEffect(() => {
        if (!data && error) {
            Swal.fire({
                icon: "error",
                title: "Error!",
                text: error?.response?.data?.message ?? "",
            });
        }
        if (data) {
            setProductionData(data?.data?.[0]);
        }
    }, [data, error]);

    useEffect(() => {
        if (dailyPlanData) {
            setProductionData(dailyPlanData?.results?.data?.[0]);
        }
    }, [dailyPlanData]);

    useEffect(() => {
        const default_data = productionData;
        // defaultValues is a react form hook.
        if (default_data) {
            var defaultValues = {};
            defaultValues.daily_production_quantity_manula =
                default_data?.daily_production_quantity_manual;
            defaultValues.on_hold_count = default_data?.on_hold_count;
            defaultValues.rejection_count = default_data?.rejection_count;
            reset(defaultValues);
        }
    }, [productionData]);

    if (loadingDailyPlanData) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    if (
        !location.state?.data ||
        !dailyPlanData ||
        !location.state?.data?.daily_plan_code
    )
        return <Error />;

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex align-items-center justify-content-center">
                        <h4 className="nk-block-title">
                            Edit Daily Production
                        </h4>
                        {isFetching ? (
                            <div
                                className="spinner-border text-primary ms-2"
                                role="status"
                            >
                                <span className="sr-only"></span>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div>
                        {privileges.includes("close-daily-plan") && (
                            <button
                                className="btn btn-sm btn-warning me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#retrun-dp-material-modal"
                                disabled={
                                    isFetching ||
                                    productionData?.activity_status === 8
                                }
                            >
                                Close Daily Plan
                            </button>
                        )}
                        <button
                            className="btn btn-sm btn-danger"
                            onClick={() => refetch()}
                            disabled={isFetching}
                        >
                            <em className="icon ni ni-reload-alt"></em>
                        </button>
                    </div>
                </div>
                <p className="mt-2">
                    <span>Last fetched on:</span>
                    <span className="ms-2">
                        {productionData?.production_last_fetched_at
                            ? moment(
                                  location.state?.data
                                      ?.production_last_fetched_at
                              ).format("DD-MM-YYYY hh:mm A")
                            : "N/A"}
                    </span>
                </p>
            </div>
            {productionData?.activity_status === 8 && (
                <div className="nk-block">
                    <span className="profile-ud-value">
                        <h3 className="text-warning">Daily plan is closed</h3>
                    </span>
                </div>
            )}
            <div className="nk-block">
                <div className="profile-ud-list">
                    <div className="profile-ud-item">
                        <div className="profile-ud wider">
                            <span className="profile-ud-label">Item Name</span>
                            <span className="profile-ud-value">
                                {productionData?.item?.item_name}
                            </span>
                        </div>
                    </div>
                    <div className="profile-ud-item">
                        <div className="profile-ud wider">
                            <span className="profile-ud-label">
                                Machine Name
                            </span>
                            <span className="profile-ud-value">
                                {productionData?.machine?.item?.item_name}
                            </span>
                        </div>
                    </div>
                    <div className="profile-ud-item">
                        <div className="profile-ud wider">
                            <span className="profile-ud-label">Work Order</span>
                            <span className="profile-ud-value">
                                {productionData?.wo?.work_order_code}
                            </span>
                        </div>
                    </div>
                    <div className="profile-ud-item">
                        <div className="profile-ud wider">
                            <span className="profile-ud-label">Daily Plan</span>
                            <span className="profile-ud-value">
                                {productionData?.daily_plan_code}
                            </span>
                        </div>
                    </div>
                    <div className="profile-ud-item">
                        <div className="profile-ud wider">
                            <span className="profile-ud-label">
                                Target Quantity
                            </span>
                            <span className="profile-ud-value">
                                {productionData?.qty_to_be_produced}
                            </span>
                        </div>
                    </div>
                    <div className="profile-ud-item">
                        <div className="profile-ud wider">
                            <span className="profile-ud-label">Date</span>
                            <span className="profile-ud-value">
                                {productionData?.date}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4 mb-2">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Daily Production Quantity
                                    </label>
                                    <p>
                                        {
                                            productionData?.daily_production_quantity
                                        }
                                    </p>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Daily Production Cycles (Shots)
                                    </label>
                                    <p>
                                        {productionData?.daily_production_count}
                                    </p>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        QC Accepted Quantity
                                    </label>
                                    <p>
                                        {productionData?.qc_accepted_quantity}
                                    </p>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        On Hold Quantity
                                    </label>
                                    <p>{productionData?.on_hold_count}</p>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Rejected Quantity
                                    </label>
                                    <p>{productionData?.rejection_count}</p>
                                </div>
                            </div>
                            <div className="row g-4 mb-2">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Daily Production Quantity Manual
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter daily production quantity"
                                        id="number-forms-daily_production_quantity"
                                        {...register(
                                            "daily_production_quantity_manula",
                                            {
                                                required: false,
                                                validate: {
                                                    positive: (value) =>
                                                        !value ||
                                                        value >= 0 ||
                                                        "Only positive numbers are allowed",
                                                },
                                            }
                                        )}
                                        disabled={
                                            !privileges?.includes(
                                                "daily_production_manual_edit"
                                            ) ||
                                            productionData?.activity_status ===
                                                8
                                        }
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {errors?.daily_production_quantity_manula && (
                                        <span className="fs-8 text-danger">
                                            {
                                                errors
                                                    ?.daily_production_quantity_manula
                                                    ?.message
                                            }
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-machine-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-update-machine"
                                                disabled={
                                                    isFetching ||
                                                    !privileges?.includes(
                                                        "daily_production_manual_edit"
                                                    ) ||
                                                    productionData?.activity_status ===
                                                        8
                                                }
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ReturnDailyPlanMaterialModal productionData={productionData} />
        </>
    );
};

export default DailyProductionEdit;
